module.exports = __webpack_public_path__ + "portal-static/img/矩形 1.5f098bdd.png";